@if (this.restaurant) {
  <div (click)="this.close($event)"
    class="modal bg-black/50 flex items-center justify-center clickClose p-4 md:p-2"
    style="z-index: 999; position: fixed; top: 0; left: 0; right: 0; bottom: 0; overflow: hidden;">
    <div #fadeInContainer
      (animationend)="this.removeFadeInFromContainer()"
      class="relative my-auto bg-white w-full h-fit max-h-[90vh] max-w-[800px] rounded flex flex-col fadeIn overflow-hidden">
      <!-- SUMMARY VIEW -->
      <div #summary class="w-full h-full flex flex-col relative">
        <!-- Fixed Header -->
        <div class="w-full flex flex-col">
          <div class="w-full p-3 md:p-6 relative flex items-start"
            style="background-image: url('/assets/images/modules/food-facade.webp'); background-size: cover; background-position: center;">
            <img [attr.src]="this.generateImageUrl(this.restaurant)" alt="Logo du restaurant"
              class="rounded hidden md:block">
              <mk-icon-button (click)="this.onCloseClick()" class="ml-auto mr-auto md:mr-0" direction="rtl" icon="cancel"
                label="Retour à la commande" useSvg="false"/>
              </div>
              <p class="py-2 md:py-4 font-semibold text-base md:text-xl text-center border-bottom-1 border-gris-3 mb-2 md:mb-3">
                Récapitulatif de la commande
              </p>
            </div>
            <!-- Scrollable Content -->
            <div class="flex-1 w-full px-2 md:px-4 flex flex-col overflow-y-auto pb-12" style="max-height: calc(90vh - 400px);">
              <p [innerText]="this.formatDate(this.date)" class="text-lg md:text-xl font-bold fg-noir-2 mt-1 md:mt-2"></p>
              <p class="text-base md:text-lg fg-noir-2 mb-1 md:mb-2 font-medium">
                Service: <span class="font-semibold">{{(this.service?.name || '').replaceAll('_',' ')}}{{this.child ? ' - ' + this.child.firstname + ' ' + this.child.lastname : ''}}{{this.service ? ' (' + this.service.mealtime_name + ')' : ''}}</span>
              </p>
              <p class="text-base md:text-lg fg-noir-2 mb-1 md:mb-2 font-medium">
                Lieu de consommation: <span class="font-semibold">{{this.enterprise?.name}}</span>
              </p>
              @if (this.cart !== null) {
                <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 justify-between pb-4">
                  <div class="col-span-1 md:col-span-2"></div>
                  @if (this.filteredCart(this.cart, false).length > 0) {
                    <p
                      class="col-span-1 md:col-span-2 block fg-noir-2 font-semibold text-base md:text-lg border border-b-0 border-l-0 border-r-0 border-gris-3 pt-2"
                      >
                      Inclus dans le menu
                    </p>
                  }
                  @for (item of this.filteredCart(this.cart, false)|orderBy: 'rankSort'; track item) {
                    <div
                      class="w-full border border-gris-3 rounded flex max-h-20 min-h-12">
                      <div class="h-full aspect-square w-24 relative" [id]="'cart-checkout-image-container-' + item.id">
                        <img [attr.src]="this.generateCourseImageUrl(item.image, item.id)"
                          [style.backgroundColor]="getBackgroundColor(item.rankId)"
                          alt="Image du plat"
                          class="h-full aspect-square object-cover w-24"
                          [id]="'cart-checkout-image-' + item.id"
                          (error)="this.onImageError($event, item)">
                        </div>
                        <p class="h-full px-2 md:px-4 py-1 md:py-2 flex-1 flex justify-start">
                          <span class="text-xs md:text-sm">
                            <span class="font-black fg-vert-1 mr-1">{{ item.quantity }}</span>
                            <span class="font-semibold max-w-[60%] fg-noir-2-contour">{{ item.name }}</span>
                          </span>
                        </p>
                        <p class="h-full px-1 md:px-2 flex justify-center items-center">
                          @if (this.isExtra(item.id)) {
                            <span
                            class="font-semibold fg-gris-1 text-xs md:text-sm">{{ item.displayedPrice|formatNumber }} €</span>
                          }
                        </p>
                      </div>
                    }
                    <!-- break line -->
                    @if (this.admission) {
                      <div class="col-span-1 md:col-span-2"></div>
                    }
                    @if (this.filteredCart(this.cart, true).length > 0 && this.admission) {
                      <p
                        class="col-span-1 md:col-span-2 block fg-noir-2 font-semibold text-base md:text-lg border border-b-0 border-l-0 border-r-0 border-gris-3 pt-2"
                        >
                        Non inclus dans le menu (extras)
                      </p>
                    }
                    @for (item of this.filteredCart(this.cart, true)|orderBy: 'rankSort'; track item.id) {
                      <div
                        class="w-full border border-gris-3 rounded flex max-h-20 min-h-12">
                        <div class="h-full aspect-square w-24 relative" [id]="'cart-checkout-image-extra-' + item.id">
                          <img [attr.src]="this.generateCourseImageUrl(item.image, item.id)"
                            [style.backgroundColor]="getBackgroundColor(item.rankId)"
                            alt="Image du plat"
                            class="h-full aspect-square object-cover w-24"
                            [id]="'cart-checkout-image-extra-' + item.id"
                            (error)="this.onImageError($event, item)">
                          </div>
                          <p class="h-full px-2 md:px-4 py-1 md:py-2 flex-1 flex justify-start">
                            <span class="text-xs md:text-sm">
                              <span class="font-black fg-vert-1 mr-1">{{ item.quantity }}</span>
                              <span class="font-semibold max-w-[60%] fg-noir-2-contour">{{ item.name }}</span>
                            </span>
                          </p>
                          <p class="h-full px-1 md:px-2 flex justify-center items-center">
                            @if (this.isExtra(item.id)) {
                              <span
                              class="font-semibold fg-gris-1 text-xs md:text-sm">{{ item.displayedPrice|formatNumber }} €</span>
                            }
                          </p>
                        </div>
                      }
                    </div>
                  }
                  <div class="w-full mb-2 md:mb-3">
                    <label for="orderComment" class="block text-sm md:text-base font-medium fg-noir-2 mb-1">
                      Commentaire pour le restaurateur (facultatif)
                    </label>
                    <mk-text-input
                      #orderComment
                      id="orderComment"
                      type="text"
                      textAlign="left"
                      displayQtyBtn="false"
                      placeholder="Ajoutez une précision sur votre commande..."
                      classes="text-sm md:text-base fg-noir-2"
                      class="w-full border border-gris-3 rounded" />
                  </div>
                </div>
              <!-- Fixed Footer -->
              <div class="w-full sticky bottom-0 bg-white p-2 md:p-4 border-t border-gris-3">
                <div class="w-full flex items-center justify-between gap-1 md:gap-2 bg-gris-4 border border-gris-3 py-2 md:py-4 px-2 md:px-4 rounded flex-col md:flex-row">
                    @if (this.enterprise && this.enterprise.isAcceptPayment) {
                      <div class="flex items-center">
                        <div class="p-1 rounded bg-vert-3 border-2 border-vert-1">
                          <svg class="w-4 h-4 md:w-6 md:h-6 fg-vert-1">
                            <use href="/assets/images/icons/icons.svg#commande"></use>
                          </svg>
                        </div>
                        <p class="font-bold fg-noir-2 text-base md:text-lg ml-1 md:ml-2 text-center">
                          <span class="font-medium">Montant à régler: </span>{{ (this.total|formatNumber) + '€' }}
                        </p>
                      </div>
                    }
                    <mk-green-action-button
                      [enabled]="true"
                      [data]="this"
                      [callback]="this.showPayementWall"
                      [baseLabel]="this.enterprise && this.enterprise.isAcceptPayment ? 'Valider et payer' : 'Valider la commande'"
                      [class.mx-auto]="!(this.enterprise && this.enterprise.isAcceptPayment)"
                      baseIcon="chevron_right"
                      class="h-[40px] md:h-[50px] w-52 md:w-64 text-base md:text-lg"
                      />
                    </div>
                  </div>
                </div>
                <!-- PAYMENTS VIEW -->
                <div #payments class="w-full h-full flex flex-col absolute top-0 left-0 transition-all translate-x-full">
                  <!-- Fixed Header -->
                  <div class="w-full flex flex-col">
                    <div class="w-full p-3 md:p-6 relative flex items-start"
                      style="background-image: url('/assets/images/modules/food-facade.webp'); background-size: cover; background-position: center;">
                      <img [attr.src]="this.generateImageUrl(this.restaurant)" alt="Logo du restaurant"
                        class="rounded hidden md:block">
                        <mk-icon-button (click)="this.onCloseClick()" class="ml-auto mr-auto md:mr-0" direction="rtl" icon="cancel"
                          label="Retour à la commande" useSvg="false"/>
                        </div>
                        <p class="py-2 md:py-4 font-semibold text-base md:text-xl text-center border-bottom-1 border-gris-3 mb-2 md:mb-3">
                          Choisissez un moyen de paiement
                        </p>
                      </div>
                      <!-- Scrollable Content -->
                      <div class="flex-1 w-full px-2 md:px-4 flex flex-col overflow-y-auto justify-center" style="max-height: calc(90vh - 400px);">
                        <div class="w-full">
                          @if (this.total > this.wallet) {
                            <p class="w-full bg-orange-400 text-white rounded p-2 text-center text-xs">
                              Vous <b>n'avez pas assez</b> de <b>crédit</b> pour <b>payer</b> cette commande. <br/>
                              <b>{{ (this.wallet|formatNumber) + '€' }}</b> seront <b>utilisés</b> du <b>porte feuille</b>. <br/> <br/>
                              <b>Vous devrez régler le reste par un autre moyen de paiement.</b>
                            </p>
                          }
                        </div>
                        <div class="w-full flex flex-wrap gap-1 md:gap-2 justify-center py-2 md:py-4">
                          @for (way of this.paymentsWays; track way) {
                            <div
                              (click)="this.togglePaymentWay(way)"
                              class="group border border-gris-3 rounded p-1 md:p-2 flex justify-center gap-1 md:gap-2 fg-gris-2 font-medium w-52 md:w-64 mx-auto cursor-pointer h-12 md:h-16 my-1"
                              [class.fg-vert-1]="this.isPaymentSelected(way)"
                              [class.font-semibold]="this.isPaymentSelected(way)"
                              [class.border-vert-1]="this.isPaymentSelected(way)"
                              [class.border-orange-1]="this.total > this.wallet && way === 'WALLET'"
                              [class.fg-orange-1]="this.total > this.wallet && way === 'WALLET'"
                              [class.hover:text-black]="way !== 'WALLET' || this.total <= this.wallet"
                              [class.hover:border-black]="way !== 'WALLET' || this.total <= this.wallet"
                              [class.hover:bg-gris-4]="way !== 'WALLET' || this.total <= this.wallet"
                              >
                              <div
                                class="group-hover:grayscale-0 grayscale my-auto"
                                [class.grayscale]="!this.isPaymentSelected(way)"
                                [innerHTML]="this.computeIconHtml(way)"
                              ></div>
                              <p class="h-fit my-auto text-center text-sm md:text-base" [innerText]="this.formatWay(way)"></p>
                            </div>
                          }
                        </div>
                      </div>
                      <!-- Fixed Footer -->
                      <div class="w-full sticky bottom-0 bg-white p-2 md:p-4 border-t border-gris-3">
                        <div class="w-full flex items-center justify-between gap-1 md:gap-2 bg-gris-4 border border-gris-3 py-2 md:py-4 px-2 md:px-4 rounded flex-col md:flex-row">
                          <div class="flex items-center">
                            <div class="p-1 rounded bg-vert-3 border-2 border-vert-1">
                              <svg class="w-4 h-4 md:w-6 md:h-6 fg-vert-1">
                                <use href="/assets/images/icons/icons.svg#commande"></use>
                              </svg>
                            </div>
                            <p class="font-bold fg-noir-2 text-base md:text-lg ml-1 md:ml-2 text-center">
                              <span class="font-medium">Montant à régler: </span>{{ (this.total|formatNumber) + '€' }}
                            </p>
                          </div>
                          <mk-green-action-button
                            class="w-40 md:w-48 h-[40px] md:h-[50px] text-sm md:text-base"
            [enabled]="(
    (this.total <= this.wallet && this.isPaymentSelected('WALLET')) ||
    (this.total > this.wallet && this.selectedPaymentsWays.length >= 2)
  )"
                            [data]="this"
                            baseLabel="Passer au paiement"
                            baseIcon="payments"
                            [callback]="this._handler_pay"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
